import Module from '../../utils/modules/Module';

export default class Hero extends Module {
  constructor(options) {
    super(options)

    this.DOMEl = this.options.element;
    this.changeImage_bind = this.changeImage.bind(this);
    this.startInterval_bind = this.startInterval.bind(this);
    this.stopInterval_bind = this.stopInterval.bind(this);
    this.images = this.DOMEl.querySelectorAll('.hero-slider-item');
    this.zone = window.innerWidth / this.images.length;
    this.title = this.DOMEl.querySelector('.hero-title');
    this.intFlash = 0;
    this.currentImage = this.DOMEl.querySelector('.hero-slider-item:last-of-type');
    this.timer = setInterval(this.checkFlash(this.intFlash), 1000);
    this.mainMenuHeight =  parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height').replace('px','')) - 58;

    //highjacked behaviour for footer logo
    this.footerReveal = document.querySelector('.footer-reveal');
    this.footerLogos = this.footerReveal.querySelectorAll('.multi-logo');
    this.changeLogo_bind = this.changeLogo.bind(this);
    this.revealZone = window.innerWidth / this.footerLogos.length;

    this.init();
  }

  /**
   * Initial state of the hero (or footer) section
   */
  init() {

    this.footerReveal.addEventListener('mousemove', this.changeLogo_bind);
    this.DOMEl.addEventListener('mousemove', this.changeImage_bind);
    this.DOMEl.addEventListener('mouseenter', this.startInterval_bind);
    this.DOMEl.addEventListener('mouseleave', this.stopInterval_bind);
  }



  /** ------------------------------
   * Events
   --------------------------------- */
  /**
   * Change image by hovering it's zone
   * Number of zones depends on the number of images
   * @param event - mouse move on hero's images
   */

  //change logo fct
  changeLogo (event) {
    let x = event.clientX;

    // hide all
    this.footerLogos.forEach(el => {
      el.style.opacity = 0;
    });

    for (let i = 1; i <= this.footerLogos.length; i++) {
      // If the cursor id between min && max
      if (x >= ((this.revealZone * i) - this.revealZone ) && x <= this.revealZone * i) {
        // show the chosen one
        let chosenImage = this.footerReveal.querySelector('.logo'+i+'');
        chosenImage.style.opacity = 1;

        // +1 to flashing when we change the image
        if (this.currentImage !== chosenImage) {
          this.intFlash++;
        }
        this.currentImage = chosenImage;
      }
    }
  }

  changeImage (event) {
    let x = event.clientX;

    // hide all
    this.images.forEach(el => {
      el.style.zIndex = -1;
    });

    for (let i = 1; i <= this.images.length; i++) {
      // If the cursor id between min && max
      if (x >= ((this.zone * i) - this.zone ) && x <= this.zone * i) {
        // show the chosen one
        let chosenImage = this.DOMEl.querySelector('.hero-slider-item:nth-of-type('+i+')');
        chosenImage.style.zIndex = 1;

        // +1 to flashing when we change the image
        if (this.currentImage !== chosenImage) {
          this.intFlash++;
        }
        this.currentImage = chosenImage;
      }
    }
  }

  /*
   * Start interval when the mouse is over the banner
   */
  startInterval () {
    let self = this;
    this.timer = setInterval(function () {
      self.checkFlash(self.intFlash);
    }, 1000);
  }

  /*
   * Stop possible flashing (after 3 in 1sec)
   * @param flashes - Number of time the images changes
   */
  checkFlash (flashes) {
    let self = this;
    if (flashes >= 3) {
      this.intFlash = 0;
      this.DOMEl.style.pointerEvents = 'none';

      setTimeout(function () {
        self.DOMEl.style.pointerEvents = 'initial';
      }, 3000);
    }
  }

  /*
   * Stop interval & reset when the mouse is out
   */
  stopInterval () {
    clearInterval(this.timer);
    this.intFlash = 0;
  }
}
